import { render, staticRenderFns } from "./ClosedAlert.vue?vue&type=template&id=63ad8da4&scoped=true&"
import script from "./ClosedAlert.vue?vue&type=script&lang=js&"
export * from "./ClosedAlert.vue?vue&type=script&lang=js&"
import style0 from "./ClosedAlert.vue?vue&type=style&index=0&id=63ad8da4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ad8da4",
  null
  
)

export default component.exports